import { useContext, useMemo, Fragment } from "react";
import { MenuItem, Divider, ListSubheader } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";

import { ModuleContext } from "../../context/ModuleContext";
import { Office365GroupContext } from "../../context/Office365GroupContext";

import { ActivityLog } from "../../operations/ActivityLog";
import { DeleteOffice365Group } from "../../operations/office365_group/DeleteOffice365Group";

const WSU_CRIMSON = "#A60F2D";

const pillSx = {
  backgroundColor: WSU_CRIMSON,
  color: "#ffffff",
  borderRadius: "999px",
  mx: 1,
  mb: 0.75,
  px: 2,
  py: 0.5,
  fontSize: "0.8rem",
  fontFamily: "'Montserrat', Arial, sans-serif",
  fontWeight: 500,
  minHeight: 32,
  "&:hover": {
    backgroundColor: "#8a0c25",
  },
};

const sectionSx = {
  fontFamily: "'Montserrat', Arial, sans-serif",
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: "0.07em",
  textTransform: "uppercase",
  color: "#4D4D4D",
  lineHeight: "28px",
  mt: 0.5,
};

export const Office365GroupOptionsMenu = () => {
  const { setModule } = useContext(ModuleContext);
  const { groupModule } = useContext(Office365GroupContext);
  const { authState } = useOktaAuth();

  const isTier3 =
      authState.accessToken.claims.itsTier3 ||
      authState.accessToken.claims.distributedItTier3;

  const launch = (element, isLog = true) => {
    setModule((prev) => ({
      ...prev,
      isVisible: true,
      userId: groupModule.id,
      element,
      isLog,
    }));
  };

  const menuItems = useMemo(() => {
    const items = [];

    const section = (label) => items.push({ type: "section", label });
    const item = (label, component, isLog = true) =>
        items.push({ type: "item", label, component, isLog });

    section("General");
    item("Tech tools action history", <ActivityLog userId={groupModule.id} />);

    section("Office 365");
    if (isTier3) {
      item("Delete Office 365 group", <DeleteOffice365Group />, true);
    }

    return items;
  }, [groupModule.id, isTier3]);

  return (
      <Fragment>
        <div style={{ marginTop: 20 }}>
          {menuItems.map((entry, i) =>
              entry.type === "section" ? (
                  <Fragment key={`section-${entry.label}`}>
                    {i !== 0 && <Divider sx={{ mx: 1, my: 0.5 }} />}
                    <ListSubheader disableSticky sx={sectionSx}>
                      {entry.label}
                    </ListSubheader>
                  </Fragment>
              ) : (
                  <MenuItem
                      key={entry.label}
                      onClick={() => launch(entry.component, entry.isLog)}
                      sx={pillSx}
                  >
                    {entry.label}
                  </MenuItem>
              )
          )}
        </div>
      </Fragment>
  );
};